const MedicalVisitReasons = [
  'visitReason.medicalOptions.allergies',
  'visitReason.medicalOptions.backPain',
  'visitReason.medicalOptions.cough',
  'visitReason.medicalOptions.eyeIrritation',
  'visitReason.medicalOptions.fever',
  'visitReason.medicalOptions.muscleAche',
  'visitReason.medicalOptions.painfulUrination',
  'visitReason.medicalOptions.sinusPain',
  'visitReason.medicalOptions.skinCondition',
  'visitReason.medicalOptions.soreThroat',
  'visitReason.medicalOptions.travelClearance',
  'visitReason.medicalOptions.upperRespiratoryInfection',
  'visitReason.medicalOptions.vomitingDiarrhea',
] as const

export const TherapyVisitReasons = [
  'visitReason.therapyOptions.anxiety',
  'visitReason.therapyOptions.depression',
  'visitReason.therapyOptions.substanceMisuse',
  'visitReason.therapyOptions.paranoia',
  'visitReason.therapyOptions.abuseSexualAssaultViolence',
  'visitReason.therapyOptions.trauma',
  'visitReason.therapyOptions.stress',
  'visitReason.therapyOptions.relationshipIssues',
  'visitReason.therapyOptions.socialServicesNeeds',
  'visitReason.therapyOptions.foodBodyImageIssues',
  'visitReason.therapyOptions.moodIssues',
] as const

export const HealthCoachVisitReasons = [
  'visitReason.healthCoachOptions.nutritionHealthyEating',
  'visitReason.healthCoachOptions.exerciseMovement',
  'visitReason.healthCoachOptions.sleepImprovement',
  'visitReason.healthCoachOptions.stressManagement',
  'visitReason.healthCoachOptions.timeManagement',
] as const

export const SuccessCoachVisitReasons = [
  'visitReason.successCoachOptions.academicPreparedness',
  'visitReason.successCoachOptions.financialWellness',
  'visitReason.successCoachOptions.careerReadiness',
] as const

export default MedicalVisitReasons
